var map = {
	"./empty-address.png": 156,
	"./empty-aftersale.png": 157,
	"./empty-cart.png": 158,
	"./empty-coupon-douyin.png": 159,
	"./empty-coupon.png": 160,
	"./empty-express.png": 161,
	"./empty-order.png": 162,
	"./empty-product.png": 163,
	"./empty-shop.png": 164,
	"./failure.png": 165,
	"./find-product-fail.png": 166,
	"./not-your-order.png": 167,
	"./time-fail.png": 168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 155;